export default __webpack_public_path__ + "5d8288ce8737df2cbfe856f640bc64e3.png";